var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXTwitterLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_2344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01561 6.43616L14.5525 0H13.2404L8.43276 5.58843L4.59289 0H0.164062L5.97069 8.4507L0.164062 15.2H1.4762L6.55321 9.29843L10.6084 15.2H15.0372L9.01529 6.43616H9.01561ZM7.21846 8.52515L6.63013 7.68365L1.94898 0.987751H3.96434L7.74209 6.39156L8.33042 7.23305L13.241 14.2572H11.2257L7.21846 8.52547V8.52515Z",
    fill: "#0E0841"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_2344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2,
    height: 15.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitterLogo);
export default __webpack_public_path__ + "static/media/x-twitter-logo.76f25ffb041b2717c1e304599063f7c4.svg";
export { ForwardRef as ReactComponent };